// Purrloaf — minimal front-end behavior.
// Single-product store: the only interactive pieces are the FAQ accordion
// (native <details>) and smooth scrolling to the offer section.

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('a[href^="#"]');
  if (!trigger) return;

  var id = trigger.getAttribute('href');
  if (id === '#' || id === '#main') return;

  var target = document.querySelector(id);
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

// Keep only one FAQ answer open at a time.
document.querySelectorAll('.faq__item').forEach(function (item) {
  item.addEventListener('toggle', function () {
    if (!item.open) return;
    document.querySelectorAll('.faq__item[open]').forEach(function (other) {
      if (other !== item) other.open = false;
    });
  });
});
